import { Card, CardContent, CardHeader, Divider, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material"
import { QuestionType } from "../types/types"

interface questionProps{
    question: QuestionType
    onChange: (questionId: number, answer: number) => void
}

const Question = ({question, onChange}: questionProps) => {

    return (
        <Card sx={{marginX: {xs: 5, sm: 10}, marginTop: 5}}>
            <CardHeader
                title={<Typography variant="h3">{question.text}</Typography>}
            />
            <CardContent sx={{marginTop: 2}}>
                <RadioGroup name="radio-buttons-group" onChange={(e, value) => onChange(question.id, +value)}>
                    {question.answers.map((answer) => (
                        <>
                            <Divider variant="fullWidth" sx={{ borderBottomWidth: 2 }}/>
                            <FormControlLabel value={answer.goddessCode} control={<Radio />} label={answer.text} />
                        </>
                    ))}
                </RadioGroup>
            </CardContent>
        </Card>
    )
}

export default Question